export class Storage {
    key;
    constructor(key) {
        this.key = key;
    }
}
